import { render, staticRenderFns } from "./SystemView.vue?vue&type=template&id=18c6f6f4&"
import script from "./SystemView.vue?vue&type=script&lang=js&"
export * from "./SystemView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports